import clsx from 'clsx'
import styles from '../VehicleAllocationColumn.module.scss'
import { VehicleAllocation } from '@/types/vehicleAllocation'
import { useUpdateVehicleAllocation, useVehicleAllocationStore } from '@/pages/VehicleAllocationController'

interface ColumnHeaderProps {
    allocation: VehicleAllocation
}

export const ColumnHeader = ({ allocation }: ColumnHeaderProps) => {
    const { allocationChanges, setAllocationChanges, routeEditing, setRouteEditing, runsWithErrors, clearStore } =
        useVehicleAllocationStore()
    const { handleUpdateVehicleAllocation } = useUpdateVehicleAllocation()

    const handleSave = () => {
        setRouteEditing(null)

        if (allocationChanges.length) {
            handleUpdateVehicleAllocation({ route: allocation.route, changes: allocationChanges })
            setAllocationChanges([])
        }
    }

    const handleCancel = () => {
        clearStore()
    }

    return (
        <div className={clsx(styles.allocationItem, styles.header)}>
            <div className={styles.run}>Run</div>
            <div className={clsx(styles.bonnetHeader, styles.run)}>
                <span>Bonnet</span>

                <div className={styles.buttons}>
                    {routeEditing === allocation.route && (
                        <button className={styles.cancelButton} onClick={handleCancel}>
                            Cancel
                        </button>
                    )}

                    {routeEditing === allocation.route ? (
                        <button
                            className={clsx(styles.editButton, {
                                [styles.editButtonDisabled]: runsWithErrors.length,
                            })}
                            disabled={runsWithErrors.length > 0}
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    ) : (
                        <button
                            className={clsx(styles.editButton, {
                                [styles.editButtonDisabled]: routeEditing !== allocation.route && routeEditing,
                            })}
                            disabled={!!routeEditing}
                            onClick={() => setRouteEditing(allocation.route)}
                        >
                            Edit
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}
